import React from "react";

export default function SizeGuide() {
    return (
        <div className="min-h-screen bg-white px-6 md:px-20 py-20">
            <h1 className="font-display text-4xl mb-8">Size Guide</h1>

            <div className="max-w-3xl text-sm text-gray-600 space-y-6 font-sans">
                <p>
                    Use the chart below to find your perfect AURÉNE fit.
                </p>

                <table className="w-full border border-gray-200 text-center">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="py-2">Size</th>
                            <th>Chest</th>
                            <th>Waist</th>
                            <th>Hip</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="border-t">
                            <td className="py-2">XS</td>
                            <td>86 cm</td>
                            <td>70 cm</td>
                            <td>88 cm</td>
                        </tr>

                        <tr className="border-t">
                            <td className="py-2">S</td>
                            <td>92 cm</td>
                            <td>76 cm</td>
                            <td>94 cm</td>
                        </tr>

                        <tr className="border-t">
                            <td className="py-2">M</td>
                            <td>98 cm</td>
                            <td>82 cm</td>
                            <td>100 cm</td>
                        </tr>

                        <tr className="border-t">
                            <td className="py-2">L</td>
                            <td>104 cm</td>
                            <td>88 cm</td>
                            <td>106 cm</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}